class PaginationInfinite extends HTMLElement {
  constructor() {
    super();

    this.gridContainer = document.querySelector(this.dataset.containerSelector);

    // Bail if there's no container
    if (!this.gridContainer) return;

    this.currentPage = parseInt(this.dataset.currentPage || 1);
    this.debouncedLoadNextPage = debounce(() => {
      this.loadNextPage();
    }, 100);

    // Create the intersection observer
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.debouncedLoadNextPage();
        }
      });
    });

    this.observer.observe(this);
  }

  loadNextPage() {
    console.log('Loading next page:', this.currentPage);
    // Bail if there's no next page URL and container
    if (this.currentPage >= parseInt(this.dataset.totalPages)) {
      this.observer.unobserve(this);
      return;
    }

    this.querySelector('.loading__spinner').classList.remove('hidden');

    const currentUrl = new URL(window.location.href);
    const currentPage = currentUrl.searchParams.get('page') || 1;
    const nextPage = parseInt(currentPage) + 1;
    this.currentPage = nextPage;
    currentUrl.searchParams.set('page', nextPage);

    // Fetch the next page
    fetch(currentUrl.href, { headers: { 'Content-Type': 'text/html' } })
      .then((response) => response.text())
      .then((html) => {
        const dom = new DOMParser().parseFromString(html, 'text/html');
        const newContainer = dom.querySelector(this.dataset.containerSelector);

        // Add cards with fade-in effect if we have a card selector
        if (this.dataset.cardSelector) {
          let count = 0;
          let newCards = Array.from(newContainer.querySelectorAll(this.dataset.cardSelector));
          newCards = this.getPageBanner(newCards);

          newCards.forEach((card) => {
            card.classList.add('u-fade-in');
            setTimeout(() => {
              this.gridContainer.insertAdjacentHTML('beforeend', card.outerHTML);
            }, count * 25);
            count++;
          });
        }
        // Otherwise, just add the new container
        else {
          this.gridContainer.insertAdjacentHTML('beforeend', newContainer.innerHTML);
        }

        this.querySelector('.loading__spinner').classList.add('hidden');

        // Push state
        window.history.pushState({ path: currentUrl.href }, '', currentUrl.href);

        // this.manangeCollectionbanners();
      });
  }
  getPageBanner(cards) {
    if (!window.collectionMidPageBanners || window.collectionMidPageBanners.length === 0) return cards;

    const bannerLiHtml = window.collectionMidPageBanners[this.currentPage - 1];
    if (!bannerLiHtml) return cards;

    const columnsMobile = parseInt(this.gridContainer.dataset.columnsMobile || 2);
    const columnsDesktop = parseInt(this.gridContainer.dataset.columnsDesktop || 4);
    const isMobile = window.innerWidth < 990;
    const columns = isMobile ? columnsMobile : columnsDesktop;

    const existingCards = Array.from(this.gridContainer.querySelectorAll('li'));
    const existingCount = existingCards.length;

    const ROWS_REMAINING = 3; // We want to insert the banner before the last two rows
    const ROWS_REMAINING_MOBILE = 3; // We want to insert the banner before the last two rows

    const finalRowsRemaining = isMobile ? ROWS_REMAINING_MOBILE : ROWS_REMAINING;

    // We'll simulate the layout to track how many elements are in each row
    let layoutCount = existingCount;
    let insertIndex = cards.length; // default to end if no full row before the end

    // banners equivalent to 2 columns in desktop or 1 column in mobile
    const bannerEquivalent = isMobile ? 1 : 1;

    const numberOfbanners = existingCards.filter((card) => card.classList.contains('grid__item--mid-banner')).length;
    layoutCount += numberOfbanners * bannerEquivalent;

    for (let i = 0; i < cards.length; i++) {
      layoutCount++;

      // Check if a new full row is starting
      if (layoutCount % columns === 0) {
        const rowsRemaining = Math.floor((cards.length - i - 1) / columns);
        if (rowsRemaining === finalRowsRemaining) {
          insertIndex = i + 1;
          break;
        }
      }
    }

    // Insert banner HTML at the calculated index
    const updatedCards = [...cards];
    const temp = document.createElement('div');
    temp.innerHTML = bannerLiHtml.trim();
    const bannerNode = temp.firstChild;

    updatedCards.splice(insertIndex, 0, bannerNode);

    return updatedCards;
  }
}

customElements.define('pagination-infinite', PaginationInfinite);
